import * as sterlingparker from './Nav.styles.sterlingparker';
import * as betprofessor from './Nav.styles.betprofessor';
import * as volcanobet from './Nav.styles.volcanobet';
import * as puntgenie from './Nav.styles.puntgenie';
import * as junglebet from './Nav.styles.junglebet';
import * as fiestabet from './Nav.styles.fiestabet';
import * as puntcity from './Nav.styles.puntcity';
import * as betgalaxy from './Nav.styles.betgalaxy';
import * as betroyale from './Nav.styles.betroyale';
import * as juicybet from './Nav.styles.juicybet';
import * as goldenrush from './Nav.styles.goldenrush';
import * as vikingbet from './Nav.styles.vikingbet';
import * as questbet from './Nav.styles.questbet';
import * as wellbet from './Nav.styles.wellbet';
import * as sugarcastle from './Nav.styles.sugarcastle';
import * as oldgill from './Nav.styles.oldgill';
import * as buffalobet from './Nav.styles.buffalobet';
import * as titanbet from './Nav.styles.titanbet';
import * as gigabet from './Nav.styles.gigabet';
import * as slambet from './Nav.styles.slambet';
import * as betstride from './Nav.styles.betstride';
import * as templebet from './Nav.styles.templebet';
import * as goldenbet888 from './Nav.styles.goldenbet888';
import * as hyperbet from './Nav.styles.hyperbet';
import * as bet777 from './Nav.styles.bet777';
import * as chromabet from './Nav.styles.chromabet';
import * as bet575 from './Nav.styles.bet575';
import * as betblast from './Nav.styles.betblast';
import * as pyramidbet from './Nav.styles.pyramidbet';
import * as magnumbet from './Nav.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
